import { Box } from '@mui/material';

export const TPA = () => {
    return <Box sx={{ flex: 1 }}></Box>;
};
